import { ImageTemplates } from "~/components/image/types";
import { WindowFormat } from "~/context/breakpoints/types";

export const imageTemplates: ImageTemplates = {
  [WindowFormat.mobile]: "productimages-mobile",
  [WindowFormat.tablet]: "productimages-tablet",
  [WindowFormat.desktop]: "productimages-regulardesktop",
  [WindowFormat.wideDesktop]: "productimages-largedesktop",
};

const PRODUCT_CARD_CLASSES_PREFIX = "ProductCard";

export const PRODUCT_CARD_CLASSES = {
  imageWrapper: `${PRODUCT_CARD_CLASSES_PREFIX}-imageWrapper`,
  image: `${PRODUCT_CARD_CLASSES_PREFIX}-image`,
  bottomTags: `${PRODUCT_CARD_CLASSES_PREFIX}-bottomTags`,
  topTags: `${PRODUCT_CARD_CLASSES_PREFIX}-topTags`,
  description: `${PRODUCT_CARD_CLASSES_PREFIX}-description`,
  title: `${PRODUCT_CARD_CLASSES_PREFIX}-title`,
  heading: `${PRODUCT_CARD_CLASSES_PREFIX}-heading`,
  price: `${PRODUCT_CARD_CLASSES_PREFIX}-price`,
  priceLink: `${PRODUCT_CARD_CLASSES_PREFIX}-priceLink`,
  pricePerUnitText: `${PRODUCT_CARD_CLASSES_PREFIX}-pricePerUnitText`,
  colors: `${PRODUCT_CARD_CLASSES_PREFIX}-colors`,
  iconsGroup: `${PRODUCT_CARD_CLASSES_PREFIX}-iconsGroup`,
};
